import Swal from 'sweetalert2';

const INPUT_ID = 'swal-input-worker-number';

/**
 * SweetAlert2 dialog to edit customer worker / עוסק / مشتغل number (Invoices V2).
 * Styled via global `.swal-worker-number-*` classes in styles.scss.
 */
export function openCustomerWorkerNumberSwal(
  curentLang: string,
  currentWorkerNumber: string,
): ReturnType<typeof Swal.fire> {
  const isAr = curentLang === 'ar';
  const isHe = curentLang === 'he';
  const dir = isAr || isHe ? 'rtl' : 'ltr';

  const title = isAr
    ? 'تحديث رقم المشتغل للعميل'
    : isHe
      ? 'עדכון מספר עוסק ללקוח'
      : 'Update customer worker number';

  const label = isAr ? 'مشتغل رقم' : isHe ? 'מספר עוסק' : 'Worker number';

  const hint = isAr
    ? 'يُستخدم لربط الزبون مع سلطة الضرائب. يجب أن يطابق رقم التسجيل الرسمي.'
    : isHe
      ? 'משמש לדיווח לרשות המסים. חייב להתאים למספר הרישום הרשמי.'
      : 'Used for tax authority reporting. Must match the official registration number.';

  const confirmText = isAr ? 'حفظ' : isHe ? 'שמור' : 'Save';
  const cancelText = isAr ? 'إلغاء' : isHe ? 'ביטול' : 'Cancel';

  const requiredMsg = isAr
    ? 'مشتغل رقم مطلوب'
    : isHe
      ? 'מספר עוסק נדרש'
      : 'Worker number is required';

  const invalidFormatMsg = isAr
    ? 'أدخل من 1 إلى 10 أرقام فقط.'
    : isHe
      ? 'הזינו 1–10 ספרות בלבד.'
      : 'Enter 1 to 10 digits only.';

  return Swal.fire({
    title: '',
    html: `
      <div class="swal-worker-number" dir="${dir}">
        <div class="swal-worker-number__hero" aria-hidden="true">
          <span class="swal-worker-number__hero-icon"><i class="fa fa-id-card"></i></span>
        </div>
        <h2 class="swal-worker-number__heading">${title}</h2>
          <p class="swal-worker-number__hint">${hint}</p>
          <p class="swal-worker-number__maxlen">${isAr ? 'بحد أقصى 10 أرقام.' : isHe ? 'עד 10 ספרות.' : 'Up to 10 digits.'}</p>
        <div class="swal-worker-number__field">
          <label class="swal-worker-number__label" for="${INPUT_ID}">${label}</label>
          <input
            id="${INPUT_ID}"
            class="swal-worker-number__input"
            type="text"
            inputmode="numeric"
            maxlength="10"
            autocomplete="off"
            spellcheck="false"
          />
        </div>
      </div>
    `,
    showCancelButton: true,
    showCloseButton: true,
    focusConfirm: false,
    confirmButtonText: confirmText,
    cancelButtonText: cancelText,
    confirmButtonColor: '#4f46e5',
    cancelButtonColor: '#6b7280',
    width: 'min(100%, 26rem)',
    padding: 0,
    customClass: {
      popup: 'swal-worker-number-popup',
      htmlContainer: 'swal-worker-number-html',
      actions: 'swal-worker-number-actions',
      confirmButton: 'swal-worker-number-btn-confirm',
      cancelButton: 'swal-worker-number-btn-cancel',
      closeButton: 'swal-worker-number-close',
    },
    didOpen: () => {
      const input = document.getElementById(INPUT_ID) as HTMLInputElement | null;
      if (!input) {
        return;
      }
      input.value = currentWorkerNumber || '';
      setTimeout(() => {
        input.focus();
        input.select?.();
      }, 50);
    },
    preConfirm: () => {
      const input = document.getElementById(INPUT_ID) as HTMLInputElement | null;
      const raw = input?.value || '';
      const trimmed = String(raw).trim();

      if (!trimmed) {
        Swal.showValidationMessage(requiredMsg);
        return false;
      }

      if (!/^\d{1,10}$/.test(trimmed)) {
        Swal.showValidationMessage(invalidFormatMsg);
        return false;
      }

      return { workerNumber: trimmed };
    },
  });
}
